// Use a relative API base in production so HTTPS pages do not trigger mixed-content errors.
import { Capacitor } from '@capacitor/core';

const isNativeApp = Capacitor.isNativePlatform();
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const apiBaseDefault =
  isLocalhost && !isNativeApp ? 'http://localhost:8000/api/v1' : '/api/v1';

export const API_BASE_URL = (import.meta.env.VITE_API_BASE || apiBaseDefault).replace(/\/+$/, '');

// Get domain base URL (without /api/v1) for image uploads, research, etc.
export const getApiBaseUrl = () => {
  const fullUrl = API_BASE_URL;
  // Remove /api/v1 from the end if it exists
  if (fullUrl.endsWith('/api/v1')) {
    return fullUrl.slice(0, -7); // Remove '/api/v1'
  }
  return fullUrl;
};

export const API_ENDPOINTS = {
  // Admin endpoints
  ADMIN_DASHBOARD_STATS: `${API_BASE_URL}/admin/dashboard/stats`,
  ADMIN_HIERARCHY_STATS: `${API_BASE_URL}/admin/hierarchy/stats`,
  ADMIN_HIERARCHY_TREE: `${API_BASE_URL}/admin/hierarchy/tree`,
  ADMIN_HIERARCHY_INITIALIZE: `${API_BASE_URL}/admin/hierarchy/initialize`,
  ADMIN_HIERARCHY_INVITE: `${API_BASE_URL}/admin/hierarchy/invite`,
  ADMIN_HIERARCHY_CREATE: `${API_BASE_URL}/admin/hierarchy/create`,
  ADMIN_ROLES: `${API_BASE_URL}/admin/roles`,
  ADMIN_USERS: `${API_BASE_URL}/admin/users`,
  ADMIN_SECURITY_ALERTS: `${API_BASE_URL}/admin/security-alerts`,
  ADMIN_SETTINGS: `${API_BASE_URL}/admin/settings`,
  
  // Auth endpoints
  ADMIN_LOGIN: `${API_BASE_URL}/auth/admin/login`,
  LOGIN: `${API_BASE_URL}/auth/login`,
  REGISTER: `${API_BASE_URL}/auth/register`,
  LOGOUT: `${API_BASE_URL}/auth/logout`,
};

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

